import React, { useEffect, useRef, useState } from 'react';
import { ButtonVariant } from '../../config/colors';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../../components/Button';
import { LinkSignUp } from '../../components/LinkSignUp';
import { Input } from '../../components/Input';
import { isValidEmail } from '../../utils/Validation';
import { authRepository } from '../../repositories/AuthRepository';
import { LoginType } from '../../models/LoginType';
import { useAuth } from '../../hooks/useAuth';
import { UserNotFoundOnLogin } from '../../repositories/Repository';
import { useConfirm } from '../../hooks/useConfirm';
import { useTheme } from '../../hooks/useTheme';
import { useLogin } from '../../hooks/useLogin';

const EmailAuth: React.FC = () => {
  const {setDataLogin} = useLogin();
  const navigate = useNavigate();
  const { openConfirm } = useConfirm();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const buttonRef = useRef<HTMLDivElement | null>(null);
  const {isMobile} = useTheme();
  const location = useLocation();
  
  useEffect(() => {
      if (inputRef.current && !isMobile) {
          inputRef.current.focus();
      }
  }, [isMobile]);

  const handleFocus = () => {
    /*setTimeout(() => {
      if (buttonRef.current)
        buttonRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
    }, 100)*/
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    authRepository.sendOtp(LoginType.EMAIL, email)
      .then((otpId) => {
        setDataLogin({ otpId, email: email, loginType: LoginType.EMAIL, npub: null });
        navigate('/login/otp', {
          state: {
            addAccount: location.state?.addAccount
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        if(error instanceof UserNotFoundOnLogin)
        {
          openConfirm({
            title: "Email not found",
            message: "The email you entered does not have an account",
            buttons: [
              { label: "Create account", href: import.meta.env.VITE_LINK_SIGNUP, target: "_blank", variant: ButtonVariant.inverted }, 
              { label: "Login with different email", onClick: () => {}, variant: ButtonVariant.transparent }
            ],
          });
        }
        else
        {
          console.error('Error sending OTP:', error);
          // @todo: handle error
        }
      });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col items-center gap-6 flex-1">
      <h1 className="text-[36px] font-bold text-white">
        Login with Email
      </h1>
        <Input
          ref={inputRef}
          placeholder="Enter your email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onFocus={handleFocus}
        />

        <div ref={buttonRef} className="w-full">
          <Button
            variant={ButtonVariant.primary}
            type="submit"
            disabled={!isValidEmail(email)}
            loading={loading}
          >
            GET CODE
          </Button>
        </div>
      <LinkSignUp />
    </form>
  );
};

export default EmailAuth;
